export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'the';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'the-citsoa@setut.com.br';
export const password = '&3Oqr{^8kH';

export const versaoSoftware = '4.4.16';
export const idioma = 'pt_BR'

export default {
}